import alt from '../alt';
import UrlHelpers from '../shared/url_helpers';
import Cart from './cart';
import { V3API } from '@reverbdotcom/discovery-ui';

class CartActions {
  cartLoaded(response) {
    return response;
  }

  loadCart() {
    return V3API.get(UrlHelpers.apiCartPath).then((response) => {
      const cart = new Cart(response);
      this.cartLoaded(cart);
    });
  }
}

export default alt.createActions(CartActions);



// WEBPACK FOOTER //
// ./javascripts/components/cart/cart_actions.js